import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { OrderModel } from 'src/app/models/order.model';
import { ProfileModel } from 'src/app/models/profile.model';
import { TourneeModel } from 'src/app/models/tournee.model';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  public producerHome = '/producer/';
  public consumerHome = '/consumer/';
  public authorityHome = '/authority/';
  public adminHome = '/admin/';

  constructor(public nav: NavController, private auth:AuthenticationService) { }

  async navigateToHome(message?:string){
    const user = await this.auth.getUser();
    if(user){
      this.nav.navigateRoot('/'+user.role+'/'+user.uid+this.addMessageToURL(message));      
    }
    else{
      console.log('go to signup');
      this.nav.navigateRoot('/signup');
    }
  }

  async viewProfile(_role?:string){
    const user = await this.auth.getUser();
    this.nav.navigateRoot('/'+_role+'/'+user.uid+'/profile');
  }

  viewPublicProfile(item:ProfileModel){
    this.nav.navigateForward('/profile/'+(item.details.role||item.role)+'/'+item.key);
  }

  navigateToSale(item:TourneeModel){
    if('market' in item){
      this.nav.navigateForward('/market/'+ item.market.key+'/'+item.key);
    }
    else{
      console.log(item);
      this.nav.navigateForward('/sale/'+ item.key);
    }
  }

  navigateBack(){
    this.nav.back();
  }

  navigateForward(path:string){
    this.nav.navigateForward(path);
  }

  navigateToOrder(item:OrderModel){
    this.nav.navigateForward('/consumer/'+ item.consumer.key +'/order/'+item.key);
  }

  navigateToMySale(item:TourneeModel){
    // if(config && config.manageTourneeView && config.manageTourneeView == 'tabs'){
      this.nav.navigateForward('/producer/'+ item.producer.key +'/sale/'+item.key+'/tabs/orders');
    // }
    // else{
    //   this.nav.navigateForward('/producer/'+ item.producer.key +'/sale/'+item.key);
    // }
  }

  navigateToMyMarket(item:TourneeModel, uid:string){
    this.nav.navigateForward('/producer/'+ uid +'/market/'+item.key);
  }

  navigateToMarket(item:TourneeModel){
    console.log('navigate to market',item);
    this.nav.navigateForward('/market/'+ item.key);      
  }

  navigateToProfile(item:ProfileModel){
    this.nav.navigateForward('/profile/'+ item.role+'/'+item.key);      
  }

  addMessageToURL(message?:string){
    if(message!== null && message!== undefined){
      return '?message='+message;
    }
    else{
      return ''
    }
  }
}
